import { render, staticRenderFns } from "./mobileSurrenderCreate.vue?vue&type=template&id=68c55580&scoped=true&"
import script from "./mobileSurrenderCreate.vue?vue&type=script&lang=js&"
export * from "./mobileSurrenderCreate.vue?vue&type=script&lang=js&"
import style0 from "./mobileSurrenderCreate.vue?vue&type=style&index=0&id=68c55580&prod&scoped=true&lang=css&"
import style1 from "./mobileSurrenderCreate.vue?vue&type=style&index=1&id=68c55580&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c55580",
  null
  
)

export default component.exports